import React, { useCallback, useState } from "react";
import * as Yup from "yup";
import {
  Row,
  Col,
  FormGroup,
  Label,
} from "reactstrap";
import Title from "../../title";
import { Field } from "formik";
import { cashesList, customStyle } from "../../appointment/utils";
import ReactSelect from "react-select";

export const FormFirstStep = (formikProps) => {
  const { errors, touched, values, setFieldValue } = formikProps;

  return (
    <div className="">
      <div className="basic-info">
        <div className="members-info-wrapper info-wrapper border-bottom-1 blk-padding-y">
          {/* <div className="info-title">
            <Title title="Start Staff Session Info"/>
          </div> */}
          <div className="info">
            <Row>
            <Col md={6}>
                <FormGroup className="custom-inputs">
                  <ReactSelect
                    name="cashId"
                    options={cashesList}
                    className={`form-control custom-inputs p-0 h-100 d-flex align-items-center mb-0 ${errors.cashId &&
                      touched.cashId &&
                      "is-invalid"}`}
                    styles={customStyle}
                    onChange={(cash) => setFieldValue("cashId", cash.id)}
                  />
                  {errors.cashId && touched.cashId ? (
                    <div className="invalid-feedback">{`${errors.cashId}`}</div>
                  ) : null}
                  <Label for="cashId">
                    Cash Name
                  </Label>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="custom-inputs">
                  <Field
                    type="number"
                    name="startCashOnSite"
                    id="startCashOnSite"
                    min={0}
                    placeholder={"Cash On Site"}
                    className={`form-control ${errors.startCashOnSite &&
                      touched.startCashOnSite &&
                      "is-invalid"}`}
                  />
                  {errors.startCashOnSite && touched.startCashOnSite ? (
                    <div className="invalid-feedback">{`${errors.startCashOnSite}`}</div>
                  ) : null}
                  <Label for="startCashOnSite">
                    Cash On Site
                  </Label>
                </FormGroup>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};
